import ArticleApi from '@api/cms/articles'


export const state = {

}

export const getters = {

}

export const mutations = {

}
  
export const actions = {
    async create({ commit, state }, payload ){
        await ArticleApi.create(payload);
    }
}